import React, { useState } from "react";
import NewLogin from "./NewLogin";
import EmailSuccess from "./NewEmailSuccessPage";
import NewLogin1 from "./NewLogin1";
import NewEmailSuccessPage1 from "./NewEmailSuccessPage1";

const LoginComponent = ({ selectedLanguage, isWhiteLabel }) => {
  const [emailVerified, setEmailVerified] = useState(false);
  const [mailId, setMailId] = useState("");

  const verifiedMail = (emailId) => {
    setMailId(emailId);
  };
  const setEmailFalse = () => {
    setEmailVerified(false);
  };

  const setEmailTrue = () => {
    setEmailVerified(true);
  };

  return (
    <div>
      {!emailVerified && !isWhiteLabel && (
        <NewLogin1
          loginTrue={setEmailTrue}
          mailId={mailId}
          setMail={verifiedMail}
          selectedLanguage={selectedLanguage}
        />
      )}
      {emailVerified && !isWhiteLabel && (
        <NewEmailSuccessPage1
          loginTrue={setEmailFalse}
          setMail={verifiedMail}
          mailId={mailId}
          selectedLanguage={selectedLanguage}
        ></NewEmailSuccessPage1>
      )}

      {!emailVerified && isWhiteLabel && (
        <NewLogin
          loginTrue={setEmailTrue}
          mailId={mailId}
          setMail={verifiedMail}
          selectedLanguage={selectedLanguage}
        />
      )}
      {emailVerified && isWhiteLabel && (
        <EmailSuccess
          loginTrue={setEmailFalse}
          setMail={verifiedMail}
          mailId={mailId}
          selectedLanguage={selectedLanguage}
        ></EmailSuccess>
      )}
    </div>
  );
};

export default LoginComponent;
